function normalizeString(value) {
  if (value === null || value === undefined) {
    return '0';
  }
  if (typeof value === 'number') {
    if (!Number.isFinite(value)) {
      throw new Error('Invalid numeric value');
    }
    value = value.toString();
  }
  const trimmed = value.toString().trim();
  if (!trimmed) {
    return '0';
  }
  if (!/^[-+]?\d*(\.\d*)?$/.test(trimmed)) {
    throw new Error(`Invalid money string: ${value}`);
  }
  return trimmed.replace(/^\+/, '');
}

export function moneyToCents(value) {
  const normalized = normalizeString(value);
  const negative = normalized.startsWith('-');
  const unsigned = negative ? normalized.slice(1) : normalized;
  const [intPartRaw = '0', decimalRaw = ''] = unsigned.split('.');
  const intPart = intPartRaw.length ? intPartRaw : '0';
  const decimalPart = (decimalRaw + '00').slice(0, 2);
  const cents = BigInt(intPart) * 100n + BigInt(decimalPart || '0');
  return negative ? -cents : cents;
}

export function centsToMoney(cents) {
  if (typeof cents === 'string' || typeof cents === 'number') {
    cents = BigInt(cents);
  }
  const negative = cents < 0n;
  const absolute = negative ? -cents : cents;
  const integerPart = absolute / 100n;
  const decimalPart = absolute % 100n;
  const decimalString = decimalPart.toString().padStart(2, '0');
  const prefix = negative ? '-' : '';
  return `${prefix}${integerPart.toString()}.${decimalString}`;
}

export function normalizeMoney(value) {
  return centsToMoney(moneyToCents(value));
}

export function addMoney(...values) {
  const total = values.reduce((acc, current) => acc + moneyToCents(current), 0n);
  return centsToMoney(total);
}

export function subtractMoney(base, ...values) {
  const result = values.reduce((acc, current) => acc - moneyToCents(current), moneyToCents(base));
  return centsToMoney(result);
}

export function multiplyMoney(value, multiplier) {
  if (!Number.isInteger(multiplier)) {
    throw new Error('Multiplier must be an integer when multiplying money');
  }
  const cents = moneyToCents(value);
  return centsToMoney(cents * BigInt(multiplier));
}

export function moneyToDisplay(value, currency = 'USD') {
  const normalized = normalizeMoney(value);
  return currency === 'USD' ? `$${normalized}` : `${normalized} ${currency}`;
}

export function centsToDisplay(cents, currency = 'USD') {
  return moneyToDisplay(centsToMoney(cents), currency);
}

export function moneyToNumber(value) {
  return Number(normalizeMoney(value));
}

export function formatMoney(value) {
  return normalizeMoney(value);
}

export default {
  moneyToCents,
  centsToMoney,
  normalizeMoney,
  addMoney,
  subtractMoney,
  multiplyMoney,
  moneyToDisplay,
  centsToDisplay,
  moneyToNumber,
  formatMoney,
};
/* eslint-env es2020 */
